import { Link } from "@StarberryUtils";
import React from "react"
import { Container, Row, Col } from 'react-bootstrap';
import { useStaticQuery, graphql } from "gatsby"
import HTMLReactParser from 'html-react-parser';
import moment from "moment/src/moment";

import { inViewOptions, containerVariants, contentItemStagger, imageZoom, fadeInFromBottom, fadeInFromRight, delayItemsFromBottom } from '../../Utils/animations';
import { motion } from "framer-motion";
import { InView } from "react-intersection-observer";

// Style
import './Magazine.scss';

const MotionRow = motion(Row);
const MotionCol = motion(Col);

const Magazine = (props) => {

    const data = useStaticQuery(graphql`
    query {
        glstrapi {
            magazines(sort: "Created_Date:desc", where:{Publish:true}) {
              About_Magazine
              Created_Date
              Tile_Image {
                url
                alternativeText
              }
              Featured
              Title
              URL
              Magazine_Major_Points {
                Add
              }
            }
          }
    }
`);

    const magazines = data.glstrapi.magazines;

    return (

        <section
            className="magazine-section"
        >
            <Container>
                {magazines.map((item, index) => (
                    <InView {...inViewOptions}>
                        {({ ref, inView }) => (
                            <>
                            {item.Featured == true &&
                                <MotionRow
                                    ref={ref}
                                    initial="hidden"
                                    animate={inView ? "visible" : "hidden"}
                                    variants={contentItemStagger}
                                >
                                    <Col>
                                        <div className="wrapper">

                                            <div className="magazine-img img-zoom">
                                                <motion.div variants={imageZoom}>
                                                    <picture>
                                                        <source media="(min-width:992px)" srcSet={item.Tile_Image.url} />
                                                        <source media="(min-width:768px)" srcSet={item.Tile_Image.url} />
                                                        <img src={item.Tile_Image.url} alt={item.Tile_Image.alternativeText ? item.Tile_Image.alternativeText : item.Title} />
                                                    </picture>
                                                </motion.div>
                                            </div>


                                            <div className="magazine-content">
                                                <motion.div variants={fadeInFromBottom}>
                                                    <h2>{item.Title}</h2>
                                                    {HTMLReactParser(item.About_Magazine.replace(/<br\s*\/?>/gi, ''))}
                                                    <div className="description">
                                                        {item.Magazine_Major_Points && item.Magazine_Major_Points.map((point, index) => (
                                                            <span className="sm-text">
                                                                <Link href="#">
                                                                    <i className="right-arrow">
                                                                    </i>
                                                                </Link>
                                                                <span className="text">
                                                                    {point.Add}</span>
                                                            </span>
                                                        ))}
                                                        <div className="btn-wrapper">
                                                            <Link to={`/magazines/${item.URL}`} className="btn btn-outline" target="_blank">
                                                                View Magazine
                                                            </Link>
                                                        </div>
                                                    </div>
                                                </motion.div>
                                            </div>
                                        </div>
                                    </Col>
                                </MotionRow>
                            }
                            </>
                        )}
                    </InView>
                ))}

                <InView {...inViewOptions}>
                    {({ ref, inView }) => (
                        <MotionRow
                            className="mag-list"
                            ref={ref}
                            initial="hidden"
                            animate={inView ? "visible" : "hidden"}
                            variants={fadeInFromRight}
                        >
                            <Col xs="12">
                                <motion.div variants={fadeInFromRight}>
                                    <div className="static-content-block">
                                        <span className="sub-title">{props.Title}</span>
                                        <h2>{props.Sub_Title}
                                        </h2>
                                    </div>
                                </motion.div>
                            </Col>
                            <Col xs="12"></Col>
                        </MotionRow>
                    )}
                </InView>

                <InView {...inViewOptions}>
                    {({ ref, inView }) => (
                        <motion.div
                            className="news-box-wrap"
                            ref={ref}
                            initial="hidden"
                            animate={inView ? "visible" : "hidden"}
                            variants={containerVariants}
                        >
                            <Row>
                                {magazines.map((item, index) => (
                                    <React.Fragment>
                                        {item.Featured == false &&
                                            <MotionCol
                                                lg={3}
                                                md={6}
                                                key={index}
                                                variants={delayItemsFromBottom}
                                                custom={index}
                                            >
                                                <Link to={`/magazines/${item.URL}`}>
                                                    <div className="news-box">
                                                        <div className="properties-wrapper img-zoom">
                                                            <picture>
                                                                <source media="(min-width:1200px)" srcSet={item.Tile_Image.url} />
                                                                <source media="(min-width:768px)" srcSet={item.Tile_Image.url} />
                                                                <img src={item.Tile_Image.url} alt={item.Tile_Image.alternativeText} />
                                                            </picture>
                                                        </div>
                                                        <div className="newsletter-info">
                                                            <div className="time-info">{moment(item.Created_Date).format("DD MMMM YYYY")}
                                                            </div>
                                                            <h3>{item.Title}</h3>
                                                        </div>
                                                    </div>
                                                </Link>
                                            </MotionCol>
                                        }
                                    </React.Fragment>
                                ))}
                            </Row>
                        </motion.div>
                    )}
                </InView>

            </Container>
        </section>

    )
}

export default Magazine